<div class="note-cell" [class.readonly]="readonly">

  <!-- Cellule vide ou valeur -->
  <div *ngIf="!readonly; else readonlyView" class="cell-edit">

    <!-- Bouton N/A -->
    <button mat-stroked-button
            class="btn-na"
            [class.active]="note?.nonApplicable"
            (click)="toggleNA()"
            matTooltip="Non applicable">
      N/A
    </button>

    <!-- Boutons 1 à 5 -->
    <button *ngFor="let v of [1,2,3,4,5]"
            mat-mini-fab
            class="btn-valeur"
            [class.selected]="note?.valeur === v"
            [class.niveau-1]="v === 1"
            [class.niveau-2]="v === 2"
            [class.niveau-3]="v === 3"
            [class.niveau-4]="v === 4"
            [class.niveau-5]="v === 5"
            (click)="selectValeur(v)"
            [matTooltip]="'Niveau ' + v">
      {{ v }}
    </button>

  </div>

  <!-- Vue lecture seule -->
  <ng-template #readonlyView>
    <span *ngIf="note?.nonApplicable" class="badge-na">N/A</span>
    <span *ngIf="note?.valeur !== null && note?.valeur !== undefined && !note?.nonApplicable"
          class="badge-valeur"
          [ngClass]="{
            'niveau-1': note?.valeur === 1,
            'niveau-2': note?.valeur === 2,
            'niveau-3': note?.valeur === 3,
            'niveau-4': note?.valeur === 4,
            'niveau-5': note?.valeur === 5
          }">
      {{ note?.valeur }}
    </span>
    <span *ngIf="!note?.nonApplicable && (note?.valeur === null || note?.valeur === undefined)"
          class="badge-vide">—</span>
  </ng-template>

</div>